import type { CryptocurrencyFormInput } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";

export const CRYPTOCURRENCY_FORM_DEFAULT_VALUES: CryptocurrencyFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
	note: "",
};
